import { GlobalCreationItem } from "client/Api/GlobalCreation/globalCreation";
import { Anchor, Icon } from "client/Components";
import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import { GlobalCreationItemIcon } from "./common";
import styles from "./CreationCard.module.less";

export type CreationCardProps = {
	item: CreationCardItem;
	onClick: () => void;
};

export const CreationCard = (props: CreationCardProps): ReactElement => {
	const {
		item,
		onClick
	} = props;

	const { name, icon } = item;

	return (
		<Anchor
			{...setTrackingId(item.trackingId)}
			className={styles.root}
			onClick={onClick}
		>
			<div className={styles.icon}>
				<Icon value={icon} />
			</div>

			<div className={styles.nameBlock}>
				<h4 className={styles.name}>
					{name}
				</h4>
			</div>
		</Anchor>
	);
};
CreationCard.displayName = "CreationCard";

export type CreationCardItem = {
	name: string;
	icon: GlobalCreationItemIcon;
	trackingId: string;
	originalItem: GlobalCreationItem;
};
